import JSConfetti from "js-confetti";

export function confetti() {
  const jsConfetti = new JSConfetti();
  jsConfetti.addConfetti({
    confettiNumber: 600,
    confettiColors: ["#FFF", "#005a3a", "#158000", "#0f5a00", "#FFF"],
  });
}
